import { Reveal, ChapterLabel } from "./Motion";
import { TRUST_CARDS } from "../../data/content";

export const TrustStrip = () => (
  <section className="bg-cream-deep/50 border-y border-line/60 py-20 sm:py-28" data-testid="trust-section">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
      <div className="max-w-2xl">
        <Reveal><ChapterLabel index="The HEARD Difference" /></Reveal>
        <Reveal delay={0.08}>
          <h2 className="serif-display mt-6 text-[2rem] sm:text-[2.7rem] font-normal text-charcoal leading-[1.12]">
            Why people will love HEARD.
          </h2>
        </Reveal>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-7">
        {TRUST_CARDS.map((c, i) => (
          <Reveal key={c.title} delay={(i % 4) * 0.07}>
            <div className="group h-full rounded-[1.4rem] border border-line bg-white/80 p-7 sm:p-8 transition-all duration-500 hover:-translate-y-1 hover:bg-white hover:shadow-[0_18px_44px_rgba(47,75,57,0.1)]">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage/12 text-sage-deep">
                <c.icon size={22} strokeWidth={1.7} />
              </span>
              <h3 className="mt-5 font-serif text-2xl font-semibold text-heading">{c.title}</h3>
              <p className="mt-2.5 text-base sm:text-sm leading-relaxed text-ink/75">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
